const validateEmail = (email: string): boolean => {
    const re = /^(([^<>()[\]\\.,; =\s@"]+(\.[^<>()[\]\\.,; =\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

const validatePhone = (phone: string): boolean  => {
    const re = /^[- +()]*[0-9][- +()0-9]*$/;
    return re.test(phone);
};

const validateWebsite = (website: string): boolean  => {
    const re = /^((?:http(?:s)?:\/\/)?[a-zA-Z0-9_-]+(?:.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,4}(?:\/[a-zA-Z0-9_]+)*(?:\/[a-zA-Z0-9_]+.[a-zA-Z]{2,4}(?:\?[a-zA-Z0-9_]+=[a-zA-Z0-9_]+)?)?(?:&[a-zA-Z0-9_]+=[a-zA-Z0-9_]+)*)$/gi; //eslint-disable-line
    return re.test(website);
};

const isEmpty = (str: string | string[]): boolean  => {
    if (!str) return true;
    if (typeof str === 'string') {
        return !str.replace(/^\s+/g, '').length;
    } else if (Array.isArray(str)) {
        return str.length > 0;
    }
    return true;
};

export {validatePhone, validateEmail, isEmpty, validateWebsite};
